var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDropSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#2b90ca",
    stroke: "#2b90ca",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M664.2 596.1c0 163.1-92.6 229.9-206.7 229.9s-206.7-66.8-206.7-229.9 206.7-426.2 206.7-426.2S664.2 433 664.2 596.1z",
    fill: "#44C0C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.5 836.3c-62.9 0-116-19.6-153.5-56.8-42.2-41.8-63.6-103.6-63.6-183.5 0-69.5 35.3-163.6 104.8-279.6 51.4-85.7 103.6-152.3 104.1-153 2-2.5 5-4 8.1-4 3.2 0 6.2 1.5 8.1 4 0.5 0.7 52.7 67.3 104.1 153 69.6 116 104.8 210 104.8 279.6 0 79.9-21.4 141.6-63.6 183.5-37.3 37.1-90.4 56.8-153.3 56.8z m0-649.4c-16.5 21.9-55.8 75.6-94.6 140.4-46.4 77.4-101.8 186.9-101.8 268.7 0 74.2 19.3 131 57.5 168.8 33.5 33.2 81.5 50.8 138.9 50.8s105.4-17.6 138.9-50.8c38.1-37.8 57.5-94.6 57.5-168.8 0-81.8-55.3-191.3-101.8-268.7-38.8-64.7-78.1-118.4-94.6-140.4z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736 115m-97.1 0a97.1 97.1 0 1 0 194.2 0 97.1 97.1 0 1 0-194.2 0Z",
    fill: "#75ffea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736 222.4c-59.2 0-107.4-48.2-107.4-107.4S676.8 7.6 736 7.6 843.4 55.8 843.4 115 795.3 222.4 736 222.4z m0-194.2c-47.8 0-86.8 38.9-86.8 86.8 0 47.8 38.9 86.8 86.8 86.8s86.8-38.9 86.8-86.8c0-47.8-38.9-86.8-86.8-86.8z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.6 511.9m-84.4 0a84.4 84.4 0 1 0 168.8 0 84.4 84.4 0 1 0-168.8 0Z",
    fill: "#75ffea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.6 606.7c-52.3 0-94.8-42.5-94.8-94.8s42.5-94.8 94.8-94.8 94.8 42.5 94.8 94.8-42.6 94.8-94.8 94.8z m0-168.9c-40.9 0-74.1 33.2-74.1 74.1 0 40.9 33.2 74.1 74.1 74.1 40.9 0 74.1-33.2 74.1-74.1 0-40.9-33.3-74.1-74.1-74.1z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.2 923.1m-84.4 0a84.4 84.4 0 1 0 168.8 0 84.4 84.4 0 1 0-168.8 0Z",
    fill: "#75ffea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.2 1017.9c-52.3 0-94.8-42.5-94.8-94.8s42.5-94.8 94.8-94.8 94.8 42.5 94.8 94.8-42.5 94.8-94.8 94.8z m0-168.9c-40.9 0-74.1 33.2-74.1 74.1 0 40.9 33.2 74.1 74.1 74.1s74.1-33.2 74.1-74.1c0-40.8-33.2-74.1-74.1-74.1z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905 621.9m-63.9 0a63.9 63.9 0 1 0 127.8 0 63.9 63.9 0 1 0-127.8 0Z",
    fill: "#75ffea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905 696.2c-40.9 0-74.2-33.3-74.2-74.2s33.3-74.2 74.2-74.2 74.2 33.3 74.2 74.2-33.3 74.2-74.2 74.2z m0-127.8c-29.5 0-53.6 24-53.6 53.6 0 29.5 24 53.6 53.6 53.6 29.5 0 53.6-24 53.6-53.6s-24.1-53.6-53.6-53.6z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2 222.9m-63.9 0a63.9 63.9 0 1 0 127.8 0 63.9 63.9 0 1 0-127.8 0Z",
    fill: "#75ffea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2 297.1c-40.9 0-74.2-33.3-74.2-74.2s33.3-74.2 74.2-74.2 74.2 33.3 74.2 74.2-33.2 74.2-74.2 74.2z m0-127.8c-29.5 0-53.6 24-53.6 53.6s24 53.6 53.6 53.6c29.5 0 53.6-24 53.6-53.6s-24-53.6-53.6-53.6z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.1 929.3m-54.5 0a54.5 54.5 0 1 0 109 0 54.5 54.5 0 1 0-109 0Z",
    fill: "#75ffea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.1 994.2c-35.8 0-64.9-29.1-64.9-64.9s29.1-64.9 64.9-64.9c35.8 0 64.9 29.1 64.9 64.9s-29.1 64.9-64.9 64.9z m0-109.1c-24.4 0-44.2 19.8-44.2 44.2 0 24.4 19.8 44.2 44.2 44.2 24.4 0 44.2-19.8 44.2-44.2 0-24.4-19.8-44.2-44.2-44.2z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.1 492.8m-65.3 0a65.3 65.3 0 1 0 130.6 0 65.3 65.3 0 1 0-130.6 0Z",
    fill: "#75ffea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.1 568.4c-41.7 0-75.6-33.9-75.6-75.6s33.9-75.6 75.6-75.6c41.7 0 75.6 33.9 75.6 75.6s-33.9 75.6-75.6 75.6z m0-130.6c-30.3 0-55 24.7-55 55s24.7 55 55 55 55-24.7 55-55c-0.1-30.4-24.7-55-55-55z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDropSvgrepoCom);
export default __webpack_public_path__ + "static/media/water-drop-svgrepo-com.861f65187de0be255a2ad0bac3d99e77.svg";
export { ForwardRef as ReactComponent };